module.exports = __webpack_public_path__ + "img/swiper-7.5eb0ed40.png";